import React from "react";
import "./Section1.css";

export default function Section1({
  heading = {},
  subHeading = "",
  subHeadingExtra = "",
  buttons = {},
  image = {},
  mobileImage = {}
}) {
  return (
    <div className=" d-flex section1">
      <div className=" heading-wrap">
        {heading}
        <div className=" fs-4 pt-4 subheading">{subHeading}</div>
        <div>{mobileImage}</div>
        <div className=" d-flex flex-column flex-md-row gap-3 gap-md-5 buttons-group">{buttons}</div>
        <div className=" fs-4 pt-2 subheading">{subHeadingExtra}</div>
      </div>
      <div>{image}</div>
    </div>
  );
}
